




















import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import { CalendarData } from "../types";

@Component
export default class BookingModal extends Vue {
    @Prop() now!: moment.Moment;
    @Prop() meetingName!: string;
    @Prop() nextMeeting!: CalendarData;
    @Prop() currentMeeting!: CalendarData | null;
    @Prop() translations!: any;
    @Prop() preview!: boolean;
    @Prop() hub!: any;
    @Prop() roomEmail!: string;
    @Prop() buttonStyle!: string;
    @Prop() buttonColor!: string;
    @Prop() subscriptionStarted!: boolean;

    isOpen = false;

    get nextBookingTimes() {
        const remainder = 15 - (this.now.minutes() % 15);
        let roundedMeeting = moment(this.now).add(remainder, "minutes");
        let amountOfButtons = 4;

        if (this.nextMeeting) {
            const minuteDifference = moment.duration(moment(this.nextMeeting.StartDateTime).startOf("minute").diff(moment(roundedMeeting).startOf("minute"))).asMinutes();
            amountOfButtons = minuteDifference / 15;
            if (amountOfButtons > 4) amountOfButtons = 4;
        }

        const nextBookingTimes = [];
        for (let index = 0; index < amountOfButtons; index++) {
            roundedMeeting = moment(roundedMeeting).add("15", "minutes");
            nextBookingTimes.push(moment(roundedMeeting));
        }

        return nextBookingTimes;
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    bookMeeting(time: moment.Moment) {
        this.close();
        if (!this.subscriptionStarted) return;
        if (this.currentMeeting) return;
        if (this.preview) return;
        console.log("Booking appointment");
        const startTime = moment().set("seconds", 0).set("milliseconds", 0);
        const endTime = moment(time).set("seconds", 0).set("milliseconds", 0);
        this.$emit("setLoading", "book");

        this.hub.invoke("createAppointment", this.roomEmail, this.translations.subjectText, "", startTime.toISOString(), endTime.toISOString()).done((result: any) => {
            if (result) {
                this.$emit("loadData");
                this.$emit("setLoading", "");
            }
        });
    }
}
